

import { EpimsBaseEntityDto } from './epim-base.dto';
export class TenementPaymentMasterDto extends EpimsBaseEntityDto {

   FacilityName: string;
   CompanyRate: number
   GovtRate: number
   AgreedRate: number
   Difference: number
   Description: string;
   CreatedBy: string;
   Remarks: string;
   Status: string;
   FacilityRegisterHostId: string;
   LgaId: string;
   Rate: number;
   ApprovalStatus: string;
   PaymentStatus: string;
   ApprovalRemarks: string;
   PaymentRemarks: string;
   Currency: string;
   FacilityRegistrationCode: string;
   LastCallDate: Date;
   NextCallDate: Date;
   FirstCallDate: Date;
   FacilityRegistrationId: string;
   ApprovedBy: string;
   DateApproved: Date;
   ApprovalComment: string;
   PaidBy: string;
   PaidDate: Date;
   PaymentComment: string;
   BulkPaymentHistoryId: string;
   ObligationPeriod: string;

}
